import * as React from 'react'

import { isMsa } from '@notes/webintegrations-common'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'
import { Dialog, IDialogProps } from 'office-ui-fabric-react/lib/Dialog'
import { LocalizationService } from '../../localization/LocalizationService'
import { Constants } from '../../shared/Constants'
import * as css from './exportdialog.css'
import { PropsFromDispatch, PropsFromState, PropsPassedIn } from './props'

// Dialog component supports children but types don't reflect it
// tslint:disable-next-line:variable-name
const DialogWithChildren = Dialog as React.ComponentType<IDialogProps & { children?: React.ReactNode }>

type Props = PropsPassedIn & PropsFromDispatch & PropsFromState

export class ExportDialog extends React.PureComponent<Props> {
  openMsaLink = () => {
    window.open(Constants.MSA_T1_EXPORT_LINK, '_blank')
  }

  openFeedbackLink = () => {
    window.open(Constants.DOGFOOD_TEAMS_CHAT, '_blank')
  }

  closeDialog = () => {
    this.props.setExportDialogVisibility(false)
  }

  renderT1ExportMessageSection = (): JSX.Element | null => {
    if (!this.props.authType) {
      return null
    }

    let exportNotesMessageLabel
    if (isMsa(this.props.authType)) {
      exportNotesMessageLabel = LocalizationService.getLocalizedString('ExportNotesMsa.Text')
    } else {
      exportNotesMessageLabel = LocalizationService.getLocalizedString('ExportNotesAad.Text')
    }
    return (
      <p>{ exportNotesMessageLabel }</p>
    )
  }

  renderButtonSection = (): JSX.Element | null => {
    if (!this.props.authType) {
      return null
    }

    if (isMsa(this.props.authType)) {
      const exportNotesLabel = LocalizationService.getLocalizedString('ExportNotes.Text')
      return (
        <PrimaryButton onClick={ this.openMsaLink } text={ exportNotesLabel } />
      )
    } else {
      // There's no link for T1 export for OrgId
      return null
    }
  }

  render(): JSX.Element {
    const closeLabel = LocalizationService.getLocalizedString('Close.Text')
    const exportNotesLabel = LocalizationService.getLocalizedString('ExportNotes.Text')
    const dialogContentProps = { title: exportNotesLabel, closeButtonAriaLabel: closeLabel }

    return (
      <DialogWithChildren
        hidden={ !this.props.isExportDialogOpen }
        onDismiss={ this.closeDialog }
        dialogContentProps={ dialogContentProps }>
        <div className={ css.exportdialogexportsection }>
          { this.renderT1ExportMessageSection() }
          { this.renderButtonSection() }
        </div>
      </DialogWithChildren>
    )
  }
}
